import { IModelCarouselLoadRequest } from './model-carousel.interface';

import { Model } from '@df/catalog/model';

export abstract class ModelCarouselEngine<T extends Model = Model> {
    abstract get(type: string, data: IModelCarouselLoadRequest): Promise<T[]>;

    // Set to true if engine outcome relates on current model
    isModelRelative = false;
}
